// extracted by mini-css-extract-plugin
export default {"list":"PaymentSection_list__bG3+m"};